export type Bonus = {
  id: string
  icon: 'target' | 'lifebuoy' | 'spotlight' | 'games' | 'growth'
  title: string
  subtitle: string
  description: string
  listLabel: string
  bullets: string[]
  payoff: string
}

export const bonuses: Bonus[] = [
  {
    id: '01',
    icon: 'target',
    title: 'Tap Teacher Correction, Cueing & Troubleshooting Mastery',
    subtitle:
      'A professional system for diagnosing problems and delivering better corrections.',
    description:
      'Knowing that something looks or sounds wrong is only the first step. The harder part is identifying why it is happening and knowing exactly what correction to give.',
    listLabel: 'This bonus helps you work through:',
    bullets: [
      'Technical mistakes',
      'Rhythm problems and timing inconsistencies',
      'Sound clarity',
      'Coordination issues',
      'Musicality problems',
      'Memory difficulties',
      'Performance issues',
      'Cue selection and regressions',
      'Corrective drills and retesting',
    ],
    payoff: 'Observe. Diagnose. Cue. Correct. Progress.',
  },
  {
    id: '02',
    icon: 'lifebuoy',
    title: 'Tap Class Rescue Vault',
    subtitle:
      '75 Ready-to-Teach Emergency, Substitute & Low-Prep Tap Classes',
    description:
      'Sometimes the original lesson plan stops working. Sometimes you are covering another instructor. Sometimes the group arrives at a completely different level than expected. Sometimes you simply need a strong class immediately.',
    listLabel: 'This bonus gives you 75 practical rescue classes across:',
    bullets: [
      'Beginner',
      'Intermediate',
      'Advanced',
      'Performance',
      'Mixed-level teaching situations',
    ],
    payoff: 'Open it. Choose the right class. Keep teaching.',
  },
  {
    id: '03',
    icon: 'spotlight',
    title: 'Tap Performance, Recital & Stage Preparation System',
    subtitle:
      'Turn recital preparation into a structured process instead of last-minute chaos.',
    description:
      'A complete preparation pathway that takes you from the first rehearsal to the final curtain without forgotten details.',
    listLabel: 'Includes professional guidance for:',
    bullets: [
      'Performance readiness',
      'Choreography cleanup',
      'Rehearsal structure and formations',
      'Memory, endurance, and recovery',
      'Stage preparation and dress rehearsals',
      'Show-day organization',
      'Post-performance assessment',
    ],
    payoff: 'Prepare. Polish. Perform.',
  },
  {
    id: '04',
    icon: 'games',
    title: '150 Tap Games, Challenges & Creative Class Activities Vault',
    subtitle: 'Add variety and engagement without losing educational purpose.',
    description:
      'These are not random entertainment games. They are teaching activities with a real instructional purpose.',
    listLabel: 'A professional library of structured activities that reinforce:',
    bullets: [
      'Rhythm and technique',
      'Listening and coordination',
      'Musicality and creativity',
      'Memory and improvisation',
      'Group interaction',
      'Performance confidence',
    ],
    payoff: 'Engage students while still developing real skills.',
  },
  {
    id: '05',
    icon: 'growth',
    title: 'Tap Instructor Business, Student Retention & Studio Growth Toolkit',
    subtitle:
      'Because teaching professionally goes beyond what happens during the combination.',
    description:
      'This bonus helps instructors strengthen the systems around their classes, with ready-to-use professional templates.',
    listLabel: 'Includes support for:',
    bullets: [
      'Student onboarding and trial classes',
      'Goal setting and retention',
      'Professional communication',
      'Student progression and re-enrollment',
      'Teaching standards and feedback',
      'Documentation and studio growth',
    ],
    payoff:
      'Build stronger classes. Retain more students. Create a stronger teaching program.',
  },
]
